__turbopack_context__.v({
  "alertBox": "index-module__CxQQwG__alertBox",
  "danger": "index-module__CxQQwG__danger",
  "info": "index-module__CxQQwG__info",
  "neutral": "index-module__CxQQwG__neutral",
  "small": "index-module__CxQQwG__small",
  "success": "index-module__CxQQwG__success",
  "title": "index-module__CxQQwG__title",
  "warning": "index-module__CxQQwG__warning",
});
